import { DatabaseFieldType, ImportedFileType } from '@databases/types/database';
import { DatabaseFilterType } from '@databases/types/database/view';

import { getTextContent } from '../../lib/dom';
import { encodeHtml } from '../../utils';
import { FieldType } from '../field-types';

const textFieldType: FieldType<DatabaseFieldType.TEXT> = {
  supportedFilterTypes: [
    DatabaseFilterType.EQUALS,
    DatabaseFilterType.CONTAINS,
    DatabaseFilterType.EMPTY,
  ],

  supportedImportTypes: [ImportedFileType.HTML, ImportedFileType.CSV],

  serializeValue: ({ value }) => ({
    body: { html: encodeHtml(value).replace(/\r|\n|\r\n/g, '<br/>') },
  }),

  deserializeValue: (params, bodyEl) =>
    bodyEl
      .clone()
      .html(bodyEl.html()?.replace(/<br *\/?>/gi, '\n') ?? '')
      .text()
      .trim() ?? '',

  renderExportView: ({ value }) => encodeHtml(value).replace(/\r|\n|\r\n/g, '<br/>'),

  parseFromHtml: (el) => getTextContent(el),

  getInitialValue: () => '',

  isEmptyValue: ({ value }) => !value,

  isEqualValue: ({ value: value1 }, { value: value2 }) => value1 === value2,

  getStringRepresentation: ({ value }) => value,
};

export default textFieldType;
